import { v4 as uuid } from 'uuid';

import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

// partial types
type OldProject = Omit<Project, 'diagram'> & {
  diagram: OldDiagramSnapshot;
};

type OldDiagramSnapshot = Omit<Project['diagram'], 'model'> & {
  model: {
    modelData: {
      competencyQuestions: string[];
    };
  };
};

/**
 * Migration to update competency questions type
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v47 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v47Projects(prevState.projects);
  }

  return nextState;
};

const v47Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, OldProject>
  ).forEach(([projectId, { diagram, ...project }]) => {
    const updatedDiagram = diagram.model?.modelData
      ? {
          ...diagram,
          model: {
            ...diagram.model,
            modelData: {
              ...diagram.model.modelData,
              competencyQuestions:
                diagram.model.modelData.competencyQuestions.map((question) => ({
                  id: uuid(),
                  question,
                })),
            },
          },
        }
      : diagram;

    projectsById[projectId] = {
      ...project,
      diagram: updatedDiagram as DiagramSnapshot,
    };
  });

  return { ...prevProjectsState, projectsById };
};
